// Constants
import {
  ERROR_BIZUM_TIMER_EXPIRED_CUSTOM_ACTION,
  ERROR_CANT_CONTINUE_CUSTOM_ACTION,
  ERROR_GO_BACK_TO_OPERATIVE_CUSTOM_ACTION,
  ERROR_HIDE_CANCEL_ONBOARDING_CUSTOM_ACTION,
  ERROR_ONBOARDING_EXPIRED_CUSTOM_ACTION,
  ERROR_SHOW_CANCEL_ONBOARDING_CUSTOM_ACTION,
} from './constants/error-log.handlers.constants';
// Enumerations
import { AppStatesEnumeration } from 'enumerations/app-states.enumeration';
// Event Handlers
import {
  customerCantContinueAndHasToReturnAmazon,
  isUploadIdBizumTimerExpiredError,
} from './utils/error.handlers.utils';
// Types
import {
  ErrorHandlersType,
  ErrorMethodsHandlersType,
  ManageErrorButtonClickHandlerType,
} from './types/error.handlers.type';
// Utilities
import { onboardingTimeLimeHasReached } from '../utils/error.utils';
import { expireCurrentOrderResolver } from 'resolvers/expire-order.resolver';

const removeAuthDataAndRedirectToAmazon = ({
  handleLogCallbackUrlCallEvent,
}: Pick<ManageErrorButtonClickHandlerType, 'handleLogCallbackUrlCallEvent'>): void => {
  handleLogCallbackUrlCallEvent();
};

const expireCurrentOnboardingAndRedirectToAmazonHandler = async (
  props: Pick<ManageErrorButtonClickHandlerType, 'handleLogCallbackUrlCallEvent'>
): Promise<void> => {
  await expireCurrentOrderResolver();
  removeAuthDataAndRedirectToAmazon(props);
};

const manageErrorButtonClickHandler = async ({
  handleSendCustomActionEvent,
  mappedError,
  handleGetOnboardingStateEvent,
  resetBoundary,
  setCurrentState,
  ...props
}: ManageErrorButtonClickHandlerType): Promise<void> => {
  switch (true) {
    case customerCantContinueAndHasToReturnAmazon(mappedError):
      handleSendCustomActionEvent(ERROR_CANT_CONTINUE_CUSTOM_ACTION + mappedError);
      removeAuthDataAndRedirectToAmazon(props);
      break;
    case onboardingTimeLimeHasReached(mappedError):
      handleSendCustomActionEvent(ERROR_ONBOARDING_EXPIRED_CUSTOM_ACTION);
      await expireCurrentOnboardingAndRedirectToAmazonHandler(props);
      break;
    case isUploadIdBizumTimerExpiredError(mappedError):
      handleSendCustomActionEvent(ERROR_BIZUM_TIMER_EXPIRED_CUSTOM_ACTION);
      setCurrentState(AppStatesEnumeration.CHECKOUT_PENDING);
      resetBoundary();
      break;
    default:
      handleSendCustomActionEvent(ERROR_GO_BACK_TO_OPERATIVE_CUSTOM_ACTION);
      await handleGetOnboardingStateEvent();
      break;
  }
};

const closeCancelApplicationModalHandler = ({
  handleSendCustomActionEvent,
  setShowModal,
}: Pick<ErrorMethodsHandlersType, 'handleSendCustomActionEvent' | 'setShowModal'>): void => {
  handleSendCustomActionEvent(ERROR_HIDE_CANCEL_ONBOARDING_CUSTOM_ACTION);
  setShowModal(false);
};

const showCancelApplicationModalHandler = ({
  handleSendCustomActionEvent,
  setShowModal,
}: Pick<ErrorMethodsHandlersType, 'handleSendCustomActionEvent' | 'setShowModal'>): void => {
  handleSendCustomActionEvent(ERROR_SHOW_CANCEL_ONBOARDING_CUSTOM_ACTION);
  setShowModal(true);
};

const ErrorHandlers = ({
  handleGetOnboardingStateEvent,
  handleLogCallbackUrlCallEvent,
  handleSendCustomActionEvent,
  mappedError,
  resetBoundary,
  setCurrentState,
  setShowModal,
}: ErrorMethodsHandlersType): ErrorHandlersType => ({
  handleCloseCancelApplicationModal: () =>
    closeCancelApplicationModalHandler({ handleSendCustomActionEvent, setShowModal }),
  handleManageErrorButtonClick: () =>
    manageErrorButtonClickHandler({
      handleSendCustomActionEvent,
      handleGetOnboardingStateEvent,
      handleLogCallbackUrlCallEvent,
      mappedError,
      resetBoundary,
      setCurrentState,
    }),
  handleShowCancelApplicationModal: () =>
    showCancelApplicationModalHandler({ handleSendCustomActionEvent, setShowModal }),
});

export { ErrorHandlers };
